import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { CadastrosService } from '../../services/cadastros.service';
import { PassosRoteamento } from '../../model/passsosroteamento';

@Component({
  selector: 'app-passosroteamento',
  templateUrl: './passosroteamento.component.html',
  styleUrls: ['./passosroteamento.component.scss']
})
export class PassosRoteamentoComponent implements OnInit {

  movSub: Subscription;
  passosroteamento: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.getpassosroteamentos();
  }

  async getpassosroteamentos(){

    this.passosroteamento = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("passosroteamento/list").subscribe(
        (result: any) =>{

          this.passosroteamento =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }

  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novopassosroteamento(){
    this.modalService.modalDetalhesPassosRoteamento.emit(null);
  }

  editar(passosroteamento: PassosRoteamento){
    this.modalService.modalDetalhesPassosRoteamento.emit(passosroteamento);
  }

  excluir(passosroteamento: PassosRoteamento){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("passosroteamento/delete", passosroteamento).subscribe(
            (result) =>{

              this.toastr.success('Passo Roteamento excluído com sucesso!', 'Sucesso!');
              this.getpassosroteamentos();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }


}
